import { render, staticRenderFns } from "./NeuCamera.vue?vue&type=template&id=36a2e355&scoped=true&"
import script from "./NeuCamera.vue?vue&type=script&lang=js&"
export * from "./NeuCamera.vue?vue&type=script&lang=js&"
import style0 from "./NeuCamera.vue?vue&type=style&index=0&id=36a2e355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2e355",
  null
  
)

export default component.exports